module.exports = __webpack_public_path__ + "img/binding_platform.5aec33ff.png";